import { Component, OnInit } from "@angular/core";
import { SignaturesService } from "../signatures.service";
import { SignaturePredefined } from "../signatures.interface";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrTranslatedService } from "../../shared/toastr-translated.service";
import { AuthService } from "../../auth/auth.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-signatures-predefined",
  templateUrl: "./signatures-predefined.component.html",
  styleUrls: ["./signatures-predefined.component.scss"],
  standalone: false,
})
export class SignaturesPredefinedComponent implements OnInit {
  public signatures: SignaturePredefined[];
  public saving = false;
  public readonly canEdit: boolean;

  public initialLoading = true;
  public isReordering = false;
  public isSendingRequest = false;

  constructor(
    private readonly service: SignaturesService,
    private readonly toastr: ToastrTranslatedService,
    private readonly dialog: MatDialog,
    private readonly translate: TranslateService,
    private readonly auth: AuthService,
    private readonly router: Router,
    readonly route: ActivatedRoute,
  ) {
    this.canEdit = this.auth.isSuperAdmin;
  }

  ngOnInit(): void {
    this.reload();
  }

  async copyPredefinedToClient(templatePredefinedId: string) {
    this.saving = true;

    const result = await this.service
      .copyPredefinedToClient(templatePredefinedId)
      .toPromise();
    const templateId = result?.templateId;
    if (!templateId) {
      this.saving = false;
      return;
    }
    await this.router.navigate(["signatures", templateId, "edit"]);
    this.toastr.success("predefined.signatureCopiedToClient");
    this.saving = false;
  }

  predefinedDetailLink(signature: SignaturePredefined): string[] | null {
    const id = signature.templatePredefinedId?.trim();
    return id ? [id] : null;
  }

  onRowClick(signature: SignaturePredefined): void {
    if (!this.canEdit || this.isReordering) {
      return;
    }
    const link = this.predefinedDetailLink(signature);
    if (!link) {
      return;
    }
    void this.router.navigate(link, {
      relativeTo: this.route,
    });
  }

  deletePredefined(templatePredefinedId: string) {
    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: this.translate.instant(
            "predefined.deleteConfirmationText",
          ) as string,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.initialLoading = true;
          this.service.deletePredefined(templatePredefinedId).subscribe(() => {
            this.toastr.success("predefined.deletedSuccess");
            this.reload();
            this.initialLoading = false;
          });
        }
      });
  }

  private reload = () => {
    this.service.getPredefined().subscribe((result: SignaturePredefined[]) => {
      this.initialLoading = false;
      this.signatures = result;
    });
  };

  public toggleReordering() {
    if (this.isReordering) {
      this.isSendingRequest = true;
      this.service
        .reorderPredefined(this.signatures.map((s) => s.templatePredefinedId))
        .subscribe(() => {
          this.toastr.success("predefined.signaturesReorderedSuccess");
          this.isReordering = !this.isReordering;
          this.isSendingRequest = false;
        });
    } else {
      this.isReordering = !this.isReordering;
    }
  }
}
